import axiosInstance from '../../helpers/axiosInstance'

export default function getAllCamposRequeridosService (inputs) {
    return axiosInstance.post('campos/getCamposBySistemas', inputs)
        .then(response => response.data)
        .catch(error => {
          throw error;
        });
}